export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topbar-2.vue?vue&type=template&id=14a0b8a4"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-2.vue?vue&type=template&id=14a0b8a4
// module id = deFY
// module chunks = 0